import React from "react";
import { Form } from "react-bootstrap";

// This is a custom UI for our 'between' or number range
// filter. It uses two number boxes and filters rows to
// ones that have values between the two
export function NumberRangeColumnFilter({
    column: { filterValue = [], preFilteredRows, setFilter, id },
}: {
    column: any;
}) {
    const [min, max] = React.useMemo(() => {
        let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
        let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
        preFilteredRows.forEach((row: any) => {
            min = Math.min(row.values[id], min);
            max = Math.max(row.values[id], max);
        });
        return [min, max];
    }, [id, preFilteredRows]);

    return (
        <div className="d-flex mt-2">
            <Form.Control
                value={filterValue[0] || ""}
                type="number"
                onChange={(e) => {
                    const val = e.target.value;
                    setFilter((old = []) => [
                        val ? parseInt(val, 10) : undefined,
                        old[1],
                    ]);
                }}
                placeholder={`Min (${min})`}
                style={{
                    width: "110px",
                }}
            />
            <span className="mx-2 mt-1">to</span>
            <Form.Control
                value={filterValue[1] || ""}
                type="number"
                onChange={(e) => {
                    const val = e.target.value;
                    setFilter((old = []) => [
                        old[0],
                        val ? parseInt(val, 10) : undefined,
                    ]);
                }}
                placeholder={`Max (${max})`}
                style={{
                    width: "110px",
                }}
            />
        </div>
    );
}



// This is a custom filter UI for selecting
// a unique option from a list
export function SelectColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}: {
    column: any;
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set();
        let tempArr: any[] = [];
        preFilteredRows.forEach((row: any) => {
            if (row?.values[id]?.length == 1) tempArr.push(row.values[id][0])
        });
        return [...new Set(tempArr.sort((a, b) => a.localeCompare(b)))];
    }, [id, preFilteredRows]);
    // const options = React.useMemo(() => {
    //     const options = new Set();
    //     preFilteredRows.forEach((row: any) => {
    //         options.add(row.values[id]);
    //     });
    //     return [...options.values()];
    // }, [id, preFilteredRows]);

    // Render a multi-select box
    return (
        <Form.Select
            value={filterValue}
            onChange={(e: any) => {
                setFilter(e.target.value || undefined);
            }}
        >
            <option value="">All</option>
            {options.map((option: any, i: any) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </Form.Select>
    );
}


export const CustomFilterMethod = (filter, row, column) => {
    const id = filter.pivotId || filter.id;
    return row[id]?.capabilities.some(capability => capability.capabilityId.name.toLowerCase().includes(filter.value.toLowerCase()))
}


// This is a custom filter UI for selecting
// a unique option from a list
export function SelectChildColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}: {
    column: any;
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach((row: any) => {
            // console.log('row', row.values[id][0]?.name);
            options.add(row.values[id][0]?.name);
        });
        return [...options.values()];
    }, [id, preFilteredRows]);

    // console.log('options', options);
    // console.log('filterValue', filterValue);

    // Render a multi-select box
    return (
        <Form.Select
            value={filterValue}
            onChange={(e: any) => {
                // console.log('e.target.value', e.target.value)
                setFilter(e.target.value || undefined);
            }}
        >
            <option value="">All</option>
            {options.map((option: any, i: any) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </Form.Select>
    );
}